"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const reporting_chip_model_1 = require("../../shared/model/reporting-chip-model");
const multilingual_type_helper_1 = require("../../../shared/multilingual-type-helper");
const page_filter_item_style_1 = require("./page-filter-item-style");
const lookup_selection_options_1 = require("./lookup-selection-options");
class PageFilterItem extends reporting_chip_model_1.ReportingChipModel {
    constructor(id, label, filterItemType, currencyId = null, searchable = null, searchCategoryName = null, defaultValues = null, searchCategoryFields = null, style = new page_filter_item_style_1.PageFilterItemStyle(), isCacheable = true, lookupSelectionType = lookup_selection_options_1.LookupSelectionOptions.MULTISELECT, mustBeConvertedToCategoryFilter = false) {
        super(id, currencyId);
        this.label = label;
        this.filterItemType = filterItemType;
        this.searchable = searchable;
        this.searchCategoryName = searchCategoryName;
        this.defaultValues = defaultValues;
        this.searchCategoryFields = searchCategoryFields;
        this.style = style;
        this.isCacheable = isCacheable;
        this.lookupSelectionType = lookupSelectionType;
        this.mustBeConvertedToCategoryFilter = mustBeConvertedToCategoryFilter;
    }
    static fromJSON(jsonObject) {
        return new PageFilterItem(jsonObject.id, multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(jsonObject.label), jsonObject.filterItemType, jsonObject.currencyId, jsonObject.searchable, jsonObject.searchCategoryName, jsonObject.defaultValues, jsonObject.searchCategoryFields, page_filter_item_style_1.PageFilterItemStyle.fromJSON(jsonObject.style), jsonObject.isCacheable, jsonObject.lookupSelectionType, jsonObject.mustBeConvertedToCategoryFilter);
    }
    toJSON() {
        return {
            id: this.id,
            label: multilingual_type_helper_1.MultilingualTypeHelper.serializeMultilingualString(this.label),
            filterItemType: this.filterItemType,
            currencyId: this.currencyId,
            searchable: this.searchable,
            searchCategoryName: this.searchCategoryName,
            defaultValues: this.defaultValues,
            searchCategoryFields: this.searchCategoryFields,
            style: this.style.toJSON(),
            isCacheable: this.isCacheable,
            lookupSelectionType: this.lookupSelectionType,
            mustBeConvertedToCategoryFilter: this.mustBeConvertedToCategoryFilter
        };
    }
}
exports.PageFilterItem = PageFilterItem;
//# sourceMappingURL=page-filter-item.js.map